import { memo } from 'react'

import { upperFirst } from 'lodash-es'
import { useTranslation } from 'react-i18next'

import { BoxLink } from 'components/LinkedMUIComponents'
import { General as StreamGeneral } from 'domains/Workspaces/Streams/General'
import { StateVisualizer } from 'domains/Workspaces/Video/Streams'
import { avcTaskConfigRoute } from 'pages/NWPlatform/Workspaces/Workspace/AvcTasks/AvcTask'
import { videoStreamGeneralRoute } from 'pages/NWPlatform/Workspaces/Workspace/Video/Streams/Stream'

const GeneralRaw = () => {
  const { t } = useTranslation(['domain'])

  const { videostreamId: streamId } = videoStreamGeneralRoute.useParams()

  return (
    <StreamGeneral
      streamKind="video"
      streamId={streamId}
      TaskLink={(taskId, content) => (
        <BoxLink
          key={taskId}
          sx={{ display: 'block', textDecoration: 'none', color: 'inherit' }}
          from={videoStreamGeneralRoute.fullPath}
          to={avcTaskConfigRoute.to}
          params={{ avcTaskId: taskId }}
        >
          {content}
        </BoxLink>
      )}
      StateSlot={(isLive) => (
        <StateVisualizer state={isLive} variant="text-sm">
          {upperFirst(isLive ? t('domain:Workspace.Streams.live') : t('domain:Workspace.Streams.ended'))}
        </StateVisualizer>
      )}
    />
  )
}

export const General = memo(GeneralRaw)
